import ReactTableBase from "../Table/ReactTableBase";
import React from "react";
import {Link} from "react-router-dom";
import styles from "../Table/ReactTableBase.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAddressBook,
    faCommentSms,
    faMailBulk,
    faMailReply, faMapPin,
    faMessage,
    faPhone,
    faSms, faUserTie
} from "@fortawesome/free-solid-svg-icons";
import renderCellActif from "../Table/RenderCellActif";
import {faMailchimp} from "@fortawesome/free-brands-svg-icons";
import RenderCellSplit from "../Table/RenderCellSplit";
import DateService from "../../services/DateService";

const CrmUserHistoryTableReferent = ({ crmUserHistory, serverSideSorting = false, onSortChange, initialSortBy }) => {
    const data = React.useMemo(() => crmUserHistory, [crmUserHistory]);

    const renderCellDateHeure = ({ value }) => {
        if (!value) return;
        return DateService.formatDate(value)
    }

    const columns = [
        {
            Header: 'Type',
            accessor: 'type',
        },
        {
            Header: 'Utilisateur',
            accessor: 'user',
            Cell: ({ value }) => <Link to={`/admin/utilisateurs/${value.id}`}>{value.nom} {value.prenom}</Link>,
        },
        {
            Header: 'Envoi',
            accessor: 'date_send',
            Cell: renderCellDateHeure,
        },
        {
            Header: 'Canal',
            accessor: 'canal_send',
            Cell: ({ value }) => {
                switch (value) {
                    case 'sms':
                        return <div><FontAwesomeIcon icon={faCommentSms}/> SMS</div>;
                    case 'email':
                        return <div><FontAwesomeIcon icon={faMailBulk}/> Email</div>;
                    default:
                        return value;
                }
            }
        },
        {
            Header: 'Détail',
            accessor: 'detail',
            Cell: ({ value, row }) => {
                return (
                    <div>
                        <div style={{padding: "4px", display: "flex", flexDirection: "row" }}>
                            <span style={{marginRight: "4px"}}><FontAwesomeIcon title={"Destinataire"}
                                                                                icon={row.original.canal_send === "sms" ? faPhone : faAddressBook}/></span>
                            <span>{value?.to ??
                                <span style={{
                                    fontSize: "0.8em",
                                    fontStyle: "italic",
                                    color: "#6e6e6e"
                                }}>Pas de données</span>}</span>
                        </div>

                        { value?.subject ?
                            <div title={"Objet"} style={{padding: "4px", display: "flex", flexDirection: "row"}}>
                                <span style={{marginRight: "4px"}}><FontAwesomeIcon icon={faMapPin}/></span>
                                <span>{ value?.subject }</span>
                            </div>
                            : null }

                        <div style={{ padding: "4px", display: "flex", flexDirection: "row" }}>
                            <span style={{marginRight: "4px"}}><FontAwesomeIcon icon={faMessage} title={"Message"}/></span>
                            <span>{value?.message ? RenderCellSplit({value: value?.message, maxLength: 300}) :
                                <span style={{
                                    fontSize: "0.8em",
                                    fontStyle: "italic",
                                    color: "#6e6e6e"
                                }}>Pas de données</span>}</span>
                        </div>
                    </div>
                );
            },
        }
    ];

    return (
        <ReactTableBase dataSource={crmUserHistory} columnsData={columns} serverSideSorting={serverSideSorting} initialSortBy={initialSortBy} onSortChange={onSortChange} />
    );
}

export default CrmUserHistoryTableReferent;